import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Instructions_ds_get_executed_instructions_by_instructionIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { instructionId: number }): 
  Promise<{ result: { InstructionId?: number, ShippingContainerId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.instructionId)) {
      missingRequiredInParams.push('\'instructionId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_get_executed_instructions_by_instructionId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { instructionId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { InstructionId?: number, ShippingContainerId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.instructionId)) {
      missingRequiredInParams.push('\'instructionId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_get_executed_instructions_by_instructionId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { instructionId: number, $keys: { InstructionId?: number, ShippingContainerId?: number }[] }): 
  Promise<{ result: { InstructionId?: number, ShippingContainerId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.instructionId)) {
      missingRequiredInParams.push('\'instructionId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_get_executed_instructions_by_instructionId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
